/**
 * 建筑专业的信号
 */

export const ARCHIBASE_SINGAL = {
    onDrawSectionFinish: "onDrawSectionFinish", // 绘制(屋面板/天沟)截面结束，返回pline
    onAssembleRoofSlapByPoint: "onAssembleRoofSlapByPoint", // 通过指定点布置屋面板
    initArrayControl: "initArrayControl", //初始化阵列控制器（初始化类型）
    onSelectMonitorObjectFinish: "onSelectMonitorObjectFinish", // 定义监测对象结束，返回监测对象图元
}